import {AccountingAccountList, AccountingAccountRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {Chip, TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";
import React, {useState} from "react";
import {FormButtonProps} from "../../../../components/form/form_inputs/form_button";

const accountTypeColor: Record<string, "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning"> = {
    ACTIVO: "info",
    PASIVO: "warning",
    NETO: "secondary",
    INGRESO: "success",
    GASTO: "error",
};

/**
 * Nivel de una cuenta por la longitud de su código, para sangrar el plan (#14623): grupo y subgrupo
 * (1-2 dígitos), cuenta del PGC (3), subcuenta del PGC (4) y subcuenta de Contasol (8). La lista va
 * ordenada por código, así que cada subcuenta queda debajo de su cuenta.
 */
const accountLevel = (code?: string) => {
    const n = (code ?? "").length;
    return n <= 2 ? 0 : n === 3 ? 1 : n < 8 ? 2 : 3;
};

export const AccountingAccountListPage = () => {
    const apiManager = useApiManager();
    const [onlyPymes, setOnlyPymes] = useState(false);

    const listConfig: AppListConfig<AccountingAccountList> = {
        title: "Plan de cuentas",
        onClick: "/app/admin/accounting/account",
        actions: [
            {
                label: onlyPymes ? "Ver plan completo" : "Solo PGC PYMES",
                action: () => setOnlyPymes(!onlyPymes),
            } as FormButtonProps,
        ],
        headers: [
            {title: "Código", width: 140},
            {title: "Nombre"},
            {title: "Entidad", width: 160},
            {title: "Tipo", width: 110},
            {title: "Naturaleza", width: 110},
            {title: "Movimientos", width: 110},
        ],
        decorator: (bean: AccountingAccountList) => {
            const entity = (bean as any).customer?.name ?? (bean as any).supplier?.name;
            return (
                <>
                    <TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : "", fontFamily: "monospace",
                        paddingLeft: 16 + 12 * accountLevel(bean.code), whiteSpace: "nowrap"}}>
                        {bean.code}
                    </TableCell>
                    <TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : "",
                        fontWeight: accountLevel(bean.code) === 0 ? 600 : undefined}}>
                        {bean.name}
                    </TableCell>
                    <TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : "", fontSize: "0.8rem"}}>
                        {entity ?? "-"}
                    </TableCell>
                    <TableCell>
                        <Chip
                            label={bean.accountType}
                            color={accountTypeColor[bean.accountType] ?? "default"}
                            size="small"
                        />
                    </TableCell>
                    <TableCell>{bean.nature ?? "-"}</TableCell>
                    <TableCell>{bean.allowsMovements ? "Sí" : "No"}</TableCell>
                </>
            );
        },
        supplier: async (currentPage, size, term, showDismissed) => {
            const ctrl = apiManager.factory(AccountingAccountRestControllerApiFactory);
            const pymesFilter = onlyPymes ? true : undefined;
            return ctrl.pageAccountingAccount(currentPage, size, undefined, undefined, undefined, undefined, undefined, pymesFilter, undefined, term, showDismissed);
        },
    };

    return <AppList config={listConfig}/>;
};
